import { useMutation } from 'react-query';

import * as listedKitResource from 'resources/listedkit/hooks/index';

import {
  updateMilestonesByDiff, updateTasksByDiff,
  updateAuditsByDiff, updateAttachedSignDocumentIdsByDiff,
} from 'resources/listedkit/workflows';

const getUpdatedListedKitMilestoneIds = ({
  listedKit, defaultMilestones, createdMilestones, milestonesDiff,
}) => {
  // collection new milestone ids to store in listedKit entity

  // If the listed kit is a ghost, we don't need to update the milestone ids since it is used for the milestone templates
  if (listedKit.is_ghost) {
    return listedKit.milestone_ids;
  }

  const milestones = listedKit?.milestones || defaultMilestones;

  const createdMilestoneIds = createdMilestones.map((m) => m.id);
  const deletedMilestoneIds = Object.keys(milestonesDiff.deleted).map((milestoneId) => milestoneId);

  const milestoneIds = [
    ...milestones.filter((milestone) => !deletedMilestoneIds.includes(milestone.id)).map((m) => m.id),
    ...createdMilestoneIds,
  ];

  return milestoneIds;
};

const useUpdateListedKitDataByDiff = ({ listedKit, defaultMilestones }) => {
  const { mutateAsync: updateListedKit } = listedKitResource.useListedKitUpdate();

  const mutation = useMutation('update-listedkit-data-by-diff', async ({
    tasksDiff, milestonesDiff, auditsDiff, attachedSignDocumentIdsDiff,
  }) => {
    const { created: createdMilestones } = await updateMilestonesByDiff(milestonesDiff);

    await Promise.all([
      updateTasksByDiff(tasksDiff), // tasks are needed to be updated after milestones
      updateAuditsByDiff(auditsDiff),
      updateAttachedSignDocumentIdsByDiff(listedKit.id, attachedSignDocumentIdsDiff),
    ]);

    // updating listedKit entity with new milestoneIds
    const updatedListedKit = await updateListedKit({
      id: listedKit.id,
      milestone_ids: getUpdatedListedKitMilestoneIds({
        listedKit, defaultMilestones, createdMilestones, milestonesDiff,
      }),
    });

    return updatedListedKit;
  });

  return mutation;
};

export default useUpdateListedKitDataByDiff;
